module.exports = __webpack_public_path__ + "static/media/omnicom.cdebc0ac.png";